import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useAuth } from '@guildeducationinc/guild-auth';
import usePathways from '@src/hooks/usePathways';
import { NEW_MAX_TABLET_QUERY } from '@src/constants';
import FeedbackWidget from '@src/remotes/FeedbackWidget/FeedbackWidget';
import { useMemberPlanContext } from '@src/context/MemberPlanContext';
import CareerPathways from '@src/components/CareerPathways/CareerPathways';
import LearnSkills from '@src/components/LearnSkills/LearnSkills';
import CareerResources from '@src/components/CareerResources/CareerResources';
import Sidebar from './Sidebar/Sidebar';
import './Layout.scss';

const Layout: React.FC = () => {
  const isMobileOrTablet = useMediaQuery(NEW_MAX_TABLET_QUERY);
  const { user } = useAuth();
  const { pathways, loading } = usePathways();

  const { memberPlan } = useMemberPlanContext();

  const { hasCareerAccelerator, hasTuitionAssistance } = memberPlan || {};

  const careerPathwaysEnabled = !!pathways.length && !loading;

  return (
    <>
      <div className='layout'>
        <div className='mainContent' data-testid='main-content'>
          {careerPathwaysEnabled && <CareerPathways />}
          {hasTuitionAssistance && <LearnSkills />}
          {(hasCareerAccelerator || careerPathwaysEnabled) && <CareerResources />}
          {user && !isMobileOrTablet && (
            <FeedbackWidget user={user} analytics={window.analytics} className='margin--top_24' />
          )}
        </div>
        <Sidebar />
      </div>
      {user && isMobileOrTablet && <FeedbackWidget user={user} analytics={window.analytics} />}
    </>
  );
};

export default Layout;
